export { default } from './ClickableCell';
export type { CellClickOptions } from './ClickableCell';
